interface Error {
    isError: true
    message: string
}

interface Ok<M> {
    isError: false
    value: M
    isStale?: boolean
}

/**
 * Represents the result of any kind of operation.
 *
 * `Ok` means the operation was successful and its result is held in `value` field.
 * `Error` means the operation was not successful and the reason of failure is held in `message` field.
 */
export type Result<M> = Error | Ok<M>

/**
 * Factory functions to build a value of `Result` interface.
 */
export const Result = {
    ok: <T>(value: T): Result<T> => ({ isError: false, value }),
    error: <T>(message: string): Result<T> => ({ isError: true, message })
}

/**
 * returns an error message of `Result`s if there's any
 */
export function findFirstError(
    ...results: Result<unknown>[]
): string | undefined {
    for (const result of results) {
        if (result.isError) {
            return result.message
        }
    }
}

export function setResultAsStale<M>(result: Ok<M>): Ok<M> {
    return { ...result, isStale: true }
}
